import { render, staticRenderFns } from "./Evento.vue?vue&type=template&id=07fc3d2a"
import script from "./Evento.vue?vue&type=script&lang=js"
export * from "./Evento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports